import '@/assets/styles/allstyle.css';
import '@/assets/styles/choose.css';
import '@/assets/styles/feature.css';
import '@/assets/styles/location.css';
import '@/assets/styles/location_content.css';
import '@/assets/styles/aboutus.css';
import '@/assets/styles/news.css';
import '@/assets/styles/instruction.css';
import '@/assets/styles/contact.css';
import '@/assets/styles/faq.css';
import '@/assets/styles/owl_ani.css';
import '@/assets/styles/hover/css/hover-min.css';
import '@/assets/styles/fontawesome/css/all.css';
import '@/assets/styles/animate/animate.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@/assets/framework/bootstrap-datepicker/dist/css/bootstrap-datepicker.standalone.min.css';

import Vue from 'vue';
import App from './App.vue';
import i18n from './i18n';
import store from './store';
import router from './router';
import VueGtag from 'vue-gtag';
import VueCarousel from 'vue-carousel';
import './registerServiceWorker';

// 讓瀏覽器的全域環境可以使用到 $ (在這裡，是為了 bootstrap-datepicker 可以正常使用)
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

// import $ from "jquery";
import 'bootstrap';

import UiInit from '@/scripts/ui-init';
import NC from '@/scripts/network-event';
import '@/scripts/native-js-expand';

Vue.config.productionTip = false;

Vue.use(VueCarousel);

//google gta
Vue.use(
  VueGtag,
  {
    config: { id: 'UA-104058887-1' },
  },
  router
);

new Vue({
  i18n,
  store,
  router,
  render: (h) => h(App),
  watch: {
    //路徑變動
    $route() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
  },
}).$mount('#app');

//初始化 UI 效果(全域型)
UiInit.initUiEffect();

//註冊偵測網路狀態事件
NC.registerNetActiveEvent();
